import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'daysAgo'})
export class DaysAgoPipe implements PipeTransform {

  constructor(private Translate: TranslateService,
              private datePipe: DatePipe) {
  }

  transform(input: string | Date, maxDays: number): string {
    const today = new Date();
    const date = input instanceof Date ? input : new Date(input);
    const daysSinceToday = Math.floor(today.getTime() / (1000 * 60 * 60 * 24));
    const daysSinceUpdate = Math.floor(date.getTime() / (1000 * 60 * 60 * 24));
    const days = daysSinceToday - daysSinceUpdate;
    if (days === 0) {
      return this.Translate.instant('days-ago.today');
    } else if (days === 1) {
      return this.Translate.instant('days-ago.yesterday');
    } else if (days > 1 && days <= maxDays) {
      return this.Translate.instant('days-ago.days', {days: days});
    } else {
      return this.Translate.instant('days-ago.on', {
        date: this.datePipe.transform(date, this.Translate.instant('order-submittals.date-format'))
      });
    }
  }

}
